import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavBarComponent } from './nav-bar.component';
import { RouterModule } from '@angular/router';
import { UserNavModule } from './user-nav/user-nav.module';
import { ComposerNavModule } from './composer-nav/composer-nav.module';

@NgModule({
  declarations: [NavBarComponent],
  imports: [CommonModule, RouterModule, UserNavModule, ComposerNavModule],
  exports: [NavBarComponent]
})
export class NavBarModule {}
